import cm from 'helpers/commons';
import React, { Component } from 'react';
import update from 'react-addons-update';
import { connect } from 'react-redux';
import { Accordion, Icon } from 'semantic-ui-react';
import PolicyDeductList from './PolicyDeductList';

//minus
const propTypes = {};

const defaultProps = {};

class StepThreeGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultVal: props.data.dataSet[0].pIdx
    };
  }

  handleClick = (e, value, isOpen) => {
    const { defaultVal } = this.state;
    const { data } = this.props;
    let nextIndex = defaultVal === value.index ? -1 : value.index;

    if (isOpen) {
      data.dataSet.some((item, idx) => {
        if (item.pIdx === value.index) {
          if (!item.isDateSetting || !item.isMoneySetting) {
            nextIndex = value.index;
            return true;
          }
          if (idx <= data.dataSet.length - 2) {
            setTimeout(() => {
              this.handleClick(null, { index: data.dataSet[idx + 1].pIdx });
            }, 500);

            return true;
          }
        }
      });
    }
    this.setState({
      defaultVal: update(this.state.defaultVal, { $set: nextIndex })
    });
  };

  render() {
    const { defaultVal } = this.state;
    const { data, fn, auth, sikdaeGroup } = this.props;

    let accordionTitle = null;
    let isGive = data.topMenu.tabType === 'give';

    let staffCheckedData = data.staffCheckedData;

    accordionTitle = data.dataSet.map((item, i) => {
      let policyStaffList = [];

      staffCheckedData.forEach((data) => {
        if (data.sPolicy == item.pIdx) {
          policyStaffList.push(data);
        }
      });

      let text = $('#time-setting' + item.pIdx).text();

      return (
        <div key={i}>
          <Accordion.Title
            className="policy-title"
            active={item.pIdx === defaultVal}
            index={item.pIdx}
            onClick={this.handleClick}
          >
            <Icon name={item.pIdx === defaultVal ? 'minus' : 'plus'} />
            <span>{item.title}</span>
            <div style={{ float: 'right' }}>
              <span className="the-last-text">
                {isGive && item.isDateSetting && item.isMoneySetting ? (
                  <span>
                    {text + '  ' + item.totalMoney}
                    <Icon name="checkmark" />
                  </span>
                ) : null}
                {isGive ? null : item.isMoneySetting ? (
                  <span>
                    {item.totalMoney}
                    <Icon name="checkmark" />
                  </span>
                ) : null}
                {isGive ? (
                  !item.isDateSetting || !item.isMoneySetting ? (
                    <span>
                      {cm.isValidNumber(item.maxHoldLimitAmount)
                        ? `(최대보유한도: ${cm.numberComma(item.maxHoldLimitAmount)}) `
                        : null}
                      설정을 완료 해주세요.
                      <Icon name="warning circle" color="red" />
                    </span>
                  ) : null
                ) : !item.isMoneySetting ? (
                  <span>
                    설정을 완료 해주세요.
                    <Icon name="warning circle" color="red" />
                  </span>
                ) : null}
              </span>
            </div>
          </Accordion.Title>
          <Accordion.Content active={item.pIdx === defaultVal}>
            <PolicyDeductList
              data={data}
              auth={auth}
              fn={fn}
              policyStaffList={policyStaffList}
              handleClick={this.handleClick}
            />
          </Accordion.Content>
        </div>
      );
    });

    return (
      <div>
        <Accordion fluid styled>
          {accordionTitle}
        </Accordion>
      </div>
    );
  }
}

StepThreeGroup.propTypes = propTypes;
StepThreeGroup.defaultProps = defaultProps;

StepThreeGroup = connect((state) => ({
  sikdaeGroup: state.commons.sikdaeGroup
}))(StepThreeGroup);

export default StepThreeGroup;
